import { createSlice } from '@reduxjs/toolkit'
import { getTaxonomiesAdmin } from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState = { 
  taxonomyAdminData: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: []
  }, 
  loading: "idle",
  error: null 
}

const taxonomyAdminSlice = createSlice({
  name: 'taxonomyAdmin',
  initialState,
  reducers: {
    cleartaxonomyAdminError: (state) => {
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getTaxonomiesAdmin.pending]: (state) => {
      state.loading = "loading"; 
      state.error = null
    },
    [getTaxonomiesAdmin.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.taxonomyAdminData = action.payload;
    },
    [getTaxonomiesAdmin.rejected]: (state, action) => {
      state.loading = "failed"; 
      state.error = action.error.message
    },
    [logOut]: (state)=> initialState
  }
})

export const {cleartaxonomyAdminError} = taxonomyAdminSlice.actions;
export default taxonomyAdminSlice.reducer